module.exports = __webpack_public_path__ + "static/media/slack.a5bf6568.svg";